import Link from "next/link";
import { Linkedin, Twitter, Youtube, Facebook, Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FOOTER_CATEGORIES, SOCIAL_LINKS } from "@/lib/navigation";
import { cn } from "@/lib/utils/cn";

const SOCIAL_ICONS: Record<string, React.ElementType> = {
  Linkedin,
  Twitter,
  Youtube,
  Facebook,
  Instagram,
};

export function PublicFooter() {
  return (
    <footer className="border-t border-border bg-neutral-50/50" role="contentinfo">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          <div className="col-span-2 md:col-span-3 lg:col-span-2 xl:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-foreground text-background text-xs font-bold">
                HR
              </span>
              <span className="font-heading font-semibold text-foreground">HRShakti</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              The professional home for HR. A verified, community-first ecosystem where HR professionals network, discuss, learn, and lead.
            </p>
            <div className="mt-4 flex items-center gap-3">
              {SOCIAL_LINKS.map((item) => {
                const Icon = SOCIAL_ICONS[item.icon];
                return (
                  <Link
                    key={item.label}
                    href={item.href}
                    className="text-muted-foreground hover:text-primary transition-colors"
                    aria-label={item.label}
                  >
                    {Icon && <Icon className="h-4 w-4" />}
                  </Link>
                );
              })}
            </div>
          </div>

          {FOOTER_CATEGORIES.map((category, idx) => (
            <div key={category.title}>
              <h4 className="eyebrow mb-5">{category.title}</h4>
              <ul className="space-y-2.5">
                {category.links.map((item) => (
                  <li key={item.href}>
                    <Link
                      href={item.href}
                      className={cn(
                        "text-sm text-muted-foreground hover:text-foreground transition-colors",
                      )}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3 text-sm text-muted-foreground">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-foreground text-background text-[10px] font-bold">
                HR
              </span>
              HR SHAKTI
            </div>
            <nav className="flex flex-wrap items-center gap-x-6 gap-y-2" aria-label="Legal">
              <Link href="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link>
              <Link href="/terms" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Terms of Service</Link>
              <Link href="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Cookie Policy</Link>
              <Link href="/sitemap" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Sitemap</Link>
            </nav>
            <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} HRShakti. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
